var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#F5F5F5"
    },
    width: 512,
    height: 170.67
  }), /*#__PURE__*/React.createElement("rect", {
    y: 341.33,
    style: {
      fill: "#73AF00"
    },
    width: 512,
    height: 170.67
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    y: 170.67,
    style: {
      fill: "#FF4B55"
    },
    width: 512,
    height: 170.67
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#FF4B55"
    },
    width: 202.1,
    height: 512
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M55.033,111.677c-0.754,0.086-1.482,0.177-2.191,0.271v9.596c0.714,0.182,1.442,0.362,2.191,0.538   C55.033,122.082,55.033,111.677,55.033,111.677z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M88.226,129.966c-2-0.16-5.074-0.468-8.744-0.916l-23.014,20.469   c2.981,0.456,6.554,1.059,8.046,1.534C70.425,145.88,78.353,138.83,88.226,129.966z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F5F5F5"
    },
    points: "122.855,97.41 122.855,96.402 122.855,95.439 82.022,95.439 82.022,96.402 82.022,97.41    82.022,98.374 122.855,98.374  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M92.625,39.013c0,2.875,4.333,5.304,9.464,5.304c5.13,0,9.464-2.429,9.464-5.304   s-4.333-5.304-9.464-5.304S92.625,36.138,92.625,39.013z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M83.775,110.378c-9.218-0.045-18.416,0.293-25.937,1.004v11.328   c8.836,1.896,19.129,3.349,25.937,4.072V110.378z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M36.29,166.284c3.643-0.077,11.646-1.517,17.064-5.75c1.68-1.312,4.547-3.727,8.578-7.229   c-2.734-0.561-7.319-1.24-9.765-1.577L36.29,166.284z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M89.032,92.635v-5.15c-0.691-1.03-1.404-2.089-2.13-3.168l-6.269,4.559   c1.247,2.144,2.048,3.507,2.195,3.758L89.032,92.635L89.032,92.635z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M40.796,115.888c-0.021,0.085-0.07,0.279,0.246,0.685c1.164,1.491,4.53,2.915,8.997,4.211v-8.42   C44.674,113.254,41.161,114.43,40.796,115.888z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M112.516,111.868v-10.69h-20.68v26.112h5.258C105.597,127.29,112.516,120.371,112.516,111.868z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M79.279,73.036c-11.072-16.321-22.897-33.472-25.782-36.87c0.413,1.52,1.412,4.373,3.743,9.715   c3.009,6.895,10.311,20.113,16.355,30.754L79.279,73.036z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M74.985,79.076c1.574,2.757,3.018,5.264,4.233,7.363l6.116-4.448   c-1.456-2.159-2.952-4.373-4.481-6.631L74.985,79.076z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M89.032,127.24v-16.796c-0.816-0.017-1.633-0.033-2.454-0.045v16.657   C87.524,127.14,88.347,127.201,89.032,127.24z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.84,
    y: 78.22,
    style: {
      fill: "#F5F5F5"
    },
    width: 20.68,
    height: 2.935
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M141.257,92.459v0.175h1.051c0.775,0,1.402,0.627,1.402,1.402v5.739   c0,0.775-0.627,1.402-1.402,1.402h-1.051v0.175c0,0.772,0.628,1.402,1.402,1.402h23.659c0.774,0,1.402-0.63,1.402-1.402v-8.894   c0-0.772-0.628-1.402-1.402-1.402h-23.659C141.885,91.057,141.257,91.687,141.257,92.459z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M167.728,166.204l-15.789-14.477c-2.445,0.337-7.031,1.016-9.765,1.577   c4.105,3.56,6.97,5.975,8.578,7.232C156.085,164.701,163.923,166.16,167.728,166.204z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F5F5F5"
    },
    points: "135.298,96.402 135.298,97.41 135.298,98.374 140.906,98.374 140.906,95.439    135.298,95.439  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M139.588,151.056c1.49-0.478,5.07-1.082,8.056-1.538l-33.906-30.257   c-0.92,2.063-2.201,3.93-3.78,5.505l0.892,0.797C123.135,136.56,132.735,145.073,139.588,151.056z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M63.621,101.353v-0.175h-1.052c-0.775,0-1.402-0.627-1.402-1.402v-5.739   c0-0.775,0.627-1.402,1.402-1.402h1.052V92.46c0-0.772-0.628-1.402-1.402-1.402H38.56c-0.774,0-1.402,0.63-1.402,1.402v8.894   c0,0.772,0.628,1.402,1.402,1.402h23.659C62.992,102.755,63.621,102.126,63.621,101.353z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F5F5F5"
    },
    points: "69.579,97.41 69.579,96.402 69.579,95.439 63.971,95.439 63.971,98.374 69.579,98.374  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M123.471,88.876l-6.269-4.559c-0.642,0.954-1.268,1.886-1.883,2.801v5.517h5.956   C121.423,92.384,122.224,91.02,123.471,88.876z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F5F5F5"
    },
    points: "93.712,69.633 110.647,69.633 106.92,65.498 97.44,65.498  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.84,
    y: 72.57,
    style: {
      fill: "#F5F5F5"
    },
    width: 20.68,
    height: 2.848
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M102.088,47.121c-1.362,0-2.64-0.175-3.856-0.434v15.848h7.799V46.67   C104.792,46.941,103.483,47.121,102.088,47.121z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M91.836,86.895h20.589c-0.004-0.176,0.026-0.346,0.09-0.516V83.96h-20.68L91.836,86.895   L91.836,86.895z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M118.77,81.991l6.116,4.448c1.215-2.099,2.66-4.606,4.234-7.363l-5.869-3.716   C121.722,77.617,120.225,79.832,118.77,81.991z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.84,
    y: 89.7,
    style: {
      fill: "#F5F5F5"
    },
    width: 20.68,
    height: 2.935
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M130.51,76.634c6.044-10.64,13.346-23.858,16.355-30.753c2.337-5.356,3.335-8.212,3.747-9.726   c-2.834,3.326-14.688,20.519-25.787,36.881L130.51,76.634z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D23741"
    },
    d: "M171.633,165.982l-18.284-16.767c-0.307-0.282-0.72-0.419-1.135-0.356  c-0.155,0.021-0.508,0.068-0.977,0.134c-0.025-0.026-0.036-0.06-0.063-0.085l-36.444-32.522c0.372-1.448,0.59-2.957,0.59-4.519  v-10.69h8.84c1.138,1.481,2.908,2.454,4.917,2.454c2.009,0,3.779-0.972,4.917-2.454h4.459v0.175c0,2.319,1.887,4.206,4.206,4.206  h23.659c2.319,0,4.206-1.887,4.206-4.206v-8.894c0-2.319-1.887-4.206-4.206-4.206h-23.659c-2.319,0-4.206,1.887-4.206,4.206v0.175  h-4.459c-1.138-1.481-2.908-2.454-4.917-2.454c-1.522,0-2.9,0.57-3.982,1.481c4.726-8.09,19.572-33.731,24.341-44.658  c5.115-11.725,4.703-13.24,3.493-14.212c-1.276-1.021-2.89,0.153-3.5,0.6c-2.345,1.704-25.093,35.31-34.11,48.703v-11.06  c0-0.031-0.016-0.057-0.018-0.088l-0.001-0.004c-0.032-0.475-0.298-0.87-0.686-1.098l-5.78-6.41V45.81  c3.342-1.434,5.52-3.913,5.52-6.797c0-4.546-5.389-8.108-12.268-8.108s-12.268,3.563-12.268,8.108c0,2.908,2.219,5.4,5.608,6.828  v17.7l-5.671,6.29c-0.426,0.241-0.725,0.68-0.725,1.204v11.426c-8.843-13.137-31.99-47.35-34.355-49.07  c-0.612-0.444-2.228-1.618-3.501-0.6c-1.21,0.972-1.622,2.486,3.493,14.212c4.617,10.58,18.68,34.952,23.859,43.834  c-0.827-0.407-1.745-0.657-2.727-0.657c-2.009,0-3.779,0.972-4.917,2.454h-4.459v-0.175c0-2.319-1.887-4.206-4.206-4.206H38.56  c-2.319,0-4.206,1.887-4.206,4.206v8.894c0,2.319,1.887,4.206,4.206,4.206h23.659c2.319,0,4.206-1.887,4.206-4.206v-0.175h4.459  c1.138,1.481,2.908,2.454,4.917,2.454s3.779-0.972,4.917-2.454h8.314v6.455c-12.999-0.279-48.983-0.32-50.956,7.576  c-0.183,0.731-0.201,1.865,0.756,3.089c3.793,4.858,23.014,8.404,36.959,10.278l-22.858,20.33c-0.028,0.025-0.04,0.06-0.065,0.087  c-0.469-0.065-0.822-0.113-0.977-0.134c-0.422-0.06-0.83,0.074-1.135,0.356l-18.285,16.767c-0.552,0.504-0.609,1.355-0.129,1.93  c0.607,0.728,2.145,1.084,4.205,1.084c5.069,0,13.29-2.161,18.531-6.254c4.32-3.374,16.286-13.864,35.569-31.184  c0.835-0.749,1.388-1.247,1.633-1.465h4.813c3.999,0,7.69-1.31,10.699-3.503l1.188,1.06c22.201,19.872,35.673,31.677,40.046,35.091  c5.241,4.096,13.46,6.254,18.529,6.254c2.061,0,3.599-0.356,4.207-1.084C172.242,167.338,172.184,166.486,171.633,165.982z   M91.836,127.29v-26.112h20.68v10.69c0,8.502-6.918,15.422-15.422,15.422H91.836z M50.039,120.784  c-4.467-1.296-7.833-2.72-8.997-4.211c-0.316-0.405-0.267-0.6-0.246-0.685c0.365-1.458,3.878-2.634,9.243-3.524V120.784z   M53.497,36.166c2.885,3.399,14.71,20.55,25.782,36.87l-5.684,3.599c-6.044-10.64-13.346-23.859-16.355-30.754  C54.909,40.539,53.911,37.685,53.497,36.166z M86.902,84.317c0.726,1.078,1.438,2.138,2.13,3.168v5.15h-6.204  c-0.148-0.251-0.948-1.614-2.195-3.758L86.902,84.317z M79.219,86.439c-1.215-2.099-2.659-4.606-4.233-7.363l5.869-3.716  c1.529,2.257,3.025,4.472,4.481,6.631L79.219,86.439z M89.032,110.445v16.796c-0.685-0.039-1.508-0.1-2.454-0.183V110.4  C87.399,110.412,88.216,110.427,89.032,110.445z M57.837,111.382c7.521-0.711,16.719-1.049,25.937-1.004v16.404  c-6.808-0.723-17.101-2.176-25.937-4.072V111.382z M52.843,111.948c0.709-0.094,1.436-0.185,2.191-0.271v10.406  c-0.749-0.176-1.476-0.356-2.191-0.538C52.843,121.545,52.843,111.948,52.843,111.948z M79.482,129.049  c3.67,0.448,6.743,0.757,8.744,0.916c-9.873,8.865-17.801,15.914-23.712,21.088c-1.492-0.476-5.064-1.079-8.046-1.534  L79.482,129.049z M61.931,153.304c-4.031,3.502-6.898,5.917-8.578,7.229c-5.418,4.233-13.42,5.674-17.064,5.75l15.877-14.557  C54.612,152.064,59.197,152.743,61.931,153.304z M82.022,98.374V97.41v-1.008v-0.964h40.833v0.964v1.008v0.964H82.022z   M111.552,39.013c0,2.875-4.333,5.304-9.464,5.304c-5.13,0-9.464-2.429-9.464-5.304s4.333-5.304,9.464-5.304  C107.218,33.709,111.552,36.138,111.552,39.013z M91.836,81.156V78.22h20.68v2.935L91.836,81.156L91.836,81.156z M112.516,83.96  v2.419c-0.064,0.17-0.094,0.34-0.09,0.516h-20.59V83.96H112.516z M91.836,75.416v-2.848h20.68v2.848H91.836z M106.92,65.498  l3.728,4.135H93.712l3.728-4.135H106.92z M98.233,62.535V46.687c1.215,0.259,2.493,0.434,3.856,0.434  c1.395,0,2.703-0.18,3.943-0.452v15.866H98.233z M91.836,89.699h20.68v2.935h-20.68V89.699z M146.865,45.881  c-3.009,6.895-10.311,20.113-16.355,30.753l-5.684-3.599c11.098-16.362,22.952-33.555,25.787-36.881  C150.2,37.669,149.202,40.525,146.865,45.881z M132.494,96.402v1.008c0,1.884-1.533,3.417-3.417,3.417s-3.417-1.533-3.417-3.417  v-1.008c0-1.884,1.533-3.417,3.417-3.417S132.494,94.519,132.494,96.402z M124.886,86.439l-6.116-4.448  c1.455-2.159,2.952-4.373,4.48-6.631l5.869,3.716C127.545,81.832,126.101,84.339,124.886,86.439z M115.32,87.118  c0.615-0.916,1.241-1.847,1.883-2.801l6.269,4.559c-1.248,2.145-2.048,3.508-2.196,3.759h-5.956V87.118z M113.738,119.261  l33.906,30.257c-2.985,0.456-6.565,1.06-8.056,1.538c-6.853-5.983-16.453-14.497-28.738-25.494l-0.892-0.797  C111.536,123.191,112.818,121.324,113.738,119.261z M151.939,151.727l15.789,14.477c-3.805-0.044-11.643-1.503-16.976-5.668  c-1.607-1.257-4.473-3.672-8.578-7.232C144.908,152.743,149.494,152.064,151.939,151.727z M167.72,92.459v8.894  c0,0.772-0.628,1.402-1.402,1.402h-23.659c-0.774,0-1.402-0.63-1.402-1.402v-0.175h1.051c0.775,0,1.402-0.627,1.402-1.402v-5.739  c0-0.775-0.627-1.402-1.402-1.402h-1.051V92.46c0-0.772,0.628-1.402,1.402-1.402h23.659C167.091,91.057,167.72,91.687,167.72,92.459  z M140.906,98.374h-5.608V97.41v-1.008v-0.964h5.608V98.374z M37.158,101.353v-8.894c0-0.772,0.628-1.402,1.402-1.402h23.659  c0.774,0,1.402,0.63,1.402,1.402v0.175h-1.052c-0.775,0-1.402,0.627-1.402,1.402v5.739c0,0.775,0.627,1.402,1.402,1.402h1.052v0.175  c0,0.772-0.628,1.402-1.402,1.402H38.56C37.786,102.755,37.158,102.126,37.158,101.353z M63.971,95.439h5.608v0.964v1.008v0.964  h-5.608V95.439z M79.218,97.41c0,1.884-1.533,3.417-3.417,3.417s-3.417-1.533-3.417-3.417v-1.008c0-1.884,1.533-3.417,3.417-3.417  s3.417,1.533,3.417,3.417V97.41z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOm);
export default __webpack_public_path__ + "static/media/om.c7a69a4be28f4b44c1d5cfacc4f3e67a.svg";
export { ForwardRef as ReactComponent };